import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import MUITable from '@material-ui/core/Table';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      tableLayout: 'fixed',
    },
  };
};

class Table extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    let { classes, children } = this.props;

    return <MUITable className={classes.root}>{children}</MUITable>;
  }
}

export default withStyles(styles)(Table);
